module.exports = __webpack_public_path__ + "img/Hornet_Nest@2x.968f46a6.png";